import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import Icons from './Icons'

const steps = [
  {
    number: '01',
    title: '注册账号',
    description: '访问okb官方网站，填写手机号或邮箱完成注册，仅需30秒即可开通账户。',
    icon: Icons.Users,
  },
  {
    number: '02',
    title: '身份认证',
    description: '上传身份证件照片，完成实名认证。高级认证可享受更高交易额度。',
    icon: Icons.Security,
  },
  {
    number: '03',
    title: '充值资金',
    description: '支持法币和数字资产充值，多种支付方式可选，资金快速到账。',
    icon: Icons.Wallet,
  },
  {
    number: '04',
    title: '开始交易',
    description: '选择您感兴趣的数字资产，开始您的投资之旅。支持现货、合约等多种交易模式。',
    icon: Icons.Chart,
  },
]

export function Guide() {
  const guideRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.guide-step',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          scrollTrigger: {
            trigger: guideRef.current,
            start: 'top 80%',
          },
        }
      )

      // Animate connecting lines
      gsap.fromTo(
        '.guide-line',
        { scaleX: 0 },
        {
          scaleX: 1,
          duration: 0.8,
          stagger: 0.15,
          delay: 0.3,
          scrollTrigger: {
            trigger: guideRef.current,
            start: 'top 80%',
          },
        }
      )
    }, guideRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={guideRef}
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#0a0a0f]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">四步开启交易</span>
          </h2>
          <p className="text-[#8080a0] text-lg max-w-2xl mx-auto">
            简单四步，即可加入okb官网，开始您的数字资产之旅
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="guide-step cyber-card text-center group">
                {/* Step Number */}
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-gradient-to-r from-[#ff00ff] to-[#00ffff] flex items-center justify-center text-sm font-bold text-white">
                  {index + 1}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-[rgba(255,0,255,0.1)] flex items-center justify-center mx-auto mb-4 group-hover:bg-[rgba(0,255,255,0.1)] transition-colors">
                  <div className="text-[#ff00ff] group-hover:text-[#00ffff] transition-colors">
                    <step.icon />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-[#e0e0ff] mb-2">
                  {step.title}
                </h3>
                <p className="text-[#8080a0] text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>

              {/* Connecting Line (hidden on last item and mobile) */}
              {index < steps.length - 1 && (
                <div className="guide-line hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-[#ff00ff] to-[#00ffff] origin-left" />
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://www.jsqkmfytwpn.com/join/1p9999"
            target="_blank"
            rel="noopener"
            className="btn-primary inline-flex items-center gap-2"
          >
            立即注册
            <Icons.ArrowRight />
          </a>
        </div>
      </div>
    </section>
  )
}
